<script lang="ts" setup>
import { computed, useSlots } from "vue";

const props = defineProps<{
  options: Record<string, unknown>[];
}>();

const emit = defineEmits<{
  itemSelected: [Record<string, unknown>];
}>();

const slots = useSlots();

const withTemplate = computed(() => !!slots["item-template"]);
</script>

<template>
  <div class="modal-body-root">
    <ul class="select-list">
      <li
        v-for="(item, index) of props.options"
        :key="`li${index}`"
        @click="emit('itemSelected', item)"
      >
        <slot name="item-template" :data="item"></slot>
        <div v-if="!withTemplate">
          {{ item.text || "" }}
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.modal-body-root,
.select-list {
  width: 100%;
  height: 100%;
}
.modal-body-root {
  max-height: 400px;
  overflow: auto;
}
li {
  background-color: #fff;
  transition: background-color 0.1s;
  border-bottom: 1px solid #efefef;
}
li:hover {
  background-color: #efefef;
  cursor: pointer;
}
</style>
